// src/components/Issues/SearchBar.js
import React from 'react';
import { TextField, InputAdornment, IconButton, Box } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

const SearchBar = ({
  searchValue,
  onSearchChange,
  onClearSearch,
  placeholder = "Search...",
  sx = {}
}) => {
  return (
    <Box sx={{ minWidth: 300, ...sx }}>
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={searchValue}
        onChange={onSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          endAdornment: searchValue && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={onClearSearch}
                edge="end"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SearchBar;